export default __webpack_public_path__ + "static/media/burgerResp.a19669d1.jpg";